module.exports = __webpack_public_path__ + "img/6.a2de9098.jpg";